// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.Detalles_boxModal__Clsl8 {
  animation: Detalles_init__EUROM 0.3s;
  transition: 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  border-radius: 5px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
}

.Detalles_boxModal__Clsl8 .Detalles_exit__\\+FpZJ {
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.Detalles_boxModal__Clsl8 .Detalles_exit__\\+FpZJ .Detalles_exitIcon__oz-2m {
  animation: Detalles_init2__dFDhV 0.3s 0.3s both;
  transition: 0.3s;
}

.Detalles_boxModal__Clsl8 .Detalles_exit__\\+FpZJ .Detalles_exitIcon__oz-2m:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.Detalles_boxModal__Clsl8 .Detalles_titleModal__7NDbt {
  animation: Detalles_init3__4jj2o 0.3s 0.3s both;
  width: 95%;
  display: flex;
  justify-items: flex-start;
  align-items: center;
}

.Detalles_boxModal__Clsl8 .Detalles_titleModal__7NDbt p {
  font-size: 1.3rem;
  margin: 0;
}

.Detalles_boxModal__Clsl8 .Detalles_titleModal__7NDbt span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.Detalles_boxModal__Clsl8 .Detalles_tableContainer__YZ-Ud {
  animation: Detalles_init2__dFDhV 0.3s both;
  overflow-y: scroll;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

@media screen and (max-width: 900px) {
  .Detalles_boxModal__Clsl8 {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@keyframes Detalles_init__EUROM {
  0% {
    top: 55%;
    opacity: 0;
  }
  100% {
    top: 50%;
    opacity: 1;
  }
}

@keyframes Detalles_init2__dFDhV {
  0% {
    transform: translateX(30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes Detalles_init3__4jj2o {
  0% {
    transform: translateX(-30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/MediosDigitales/Modales/ModalDetalles/Detalles.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,oCAAoB;EACpB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+CAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,+CAA+B;EAC/B,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0CAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.3s;\n  transition: 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  overflow: scroll;\n  overflow-x: hidden;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  border-radius: 5px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.boxModal .exit .exitIcon {\n  animation: init2 0.3s 0.3s both;\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  animation: init3 0.3s 0.3s both;\n  width: 95%;\n  display: flex;\n  justify-items: flex-start;\n  align-items: center;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .tableContainer {\n  animation: init2 0.3s both;\n  overflow-y: scroll;\n  max-height: 90%;\n  border-radius: 10px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n@keyframes init {\n  0% {\n    top: 55%;\n    opacity: 0;\n  }\n  100% {\n    top: 50%;\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes init3 {\n  0% {\n    transform: translateX(-30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `Detalles_boxModal__Clsl8`,
	"init": `Detalles_init__EUROM`,
	"exit": `Detalles_exit__+FpZJ`,
	"exitIcon": `Detalles_exitIcon__oz-2m`,
	"init2": `Detalles_init2__dFDhV`,
	"titleModal": `Detalles_titleModal__7NDbt`,
	"init3": `Detalles_init3__4jj2o`,
	"tableContainer": `Detalles_tableContainer__YZ-Ud`
};
export default ___CSS_LOADER_EXPORT___;
